import { ESpamListActionTypes, ISpamListRequest } from './types';
import { TChatDataInListSchema } from '../../types/chatList';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Запрос за списком спам чатов
 */
export const setSpamListPending = actionGenerator<ESpamListActionTypes.SetPending, ISpamListRequest>(
  ESpamListActionTypes.SetPending,
);

/**
 * Установить список спам чатов
 */
export const setSpamListSucceed = actionGenerator<ESpamListActionTypes.SetSucceed, TChatDataInListSchema[]>(
  ESpamListActionTypes.SetSucceed,
);

/**
 * Установить ошибку запроса списка спам чатов
 */
export const setSpamListFailed = actionGenerator<ESpamListActionTypes.SetFailed, void>(ESpamListActionTypes.SetFailed);
